import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { sdkMobileMediaTokenUpdated } from 'features/sdk/actions';

export function* mobileMediaTokenUpdatedSaga(data: ReturnType<typeof sdkMobileMediaTokenUpdated>) {
  yield call(eventBus.sendMessage, 'mobileMediaTokenUpdated', {}, { token: data.payload });
}
